import { onDelegatedClick, onReady } from '@/core/utils/dom';
import { COOKIE_PREFERENCES_FRAGMENT } from './privacy.config';
import {
	hasCookiePreferences,
	showCookiePreferences,
} from './vendors/ketch/ketch.adapter.client';

export function init(): void {
	onReady(() => {
		onDelegatedClick(`a[href="#${COOKIE_PREFERENCES_FRAGMENT}"]`, (event) => {
			if (!hasCookiePreferences()) return;

			event.preventDefault();
			showCookiePreferences();
		});
	});
}
